import {setupAjaxConfiguration} from "ajaxSetup";
import router from 'routers/credits.router';

require('js/traits/google-analytics');

setupAjaxConfiguration(router, undefined, (xhr) => {
    if (xhr.getResponseHeader("isPostpaid") === "true") {
        $("#creditsPageBody").remove();

        // Redirect user in dashboard.
        sessionStorage.setItem("referrer", location.pathname + location.hash);
        window.open('Login.htm', '_self');
    }
}).then(() => console.log("Ajax setup done."));